module.exports = __webpack_public_path__ + "static/media/MCT-Web-Slider_0_1020px.eaa01e64.jpg";